import { EarthArrowRightIcon } from './EarthArrowRightIcon';

/**
 * author: Michael Irigoyen
 * id E6C7261B-1CC0-41EA-844B-0DA761CDCC12
 * name earth-arrow-right
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-arrow-right.svg
 * tags
 * - Navigation 
 */
export const GlobeArrowRightIcon = EarthArrowRightIcon;
export default GlobeArrowRightIcon